import React, { useEffect, useRef } from "react";

type Consumer = {
    id: string;
    track?: MediaStreamTrack;
};

interface Props {
    consumers: Consumer[];
}

const AllAudioConsumers: React.FC<Props> = ({ consumers }) => {
    const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});

    useEffect(() => {
        consumers
            ?.filter((c: any) => (c.track?.kind || c.kind) === "audio" && c.track?.readyState === "live")
            ?.forEach((consumer) => {
                const audioEl = audioRefs.current[consumer.id];
                if (audioEl && consumer.track) {
                    const stream = new MediaStream([consumer.track]);
                    if (audioEl.srcObject !== stream) {
                        audioEl.srcObject = stream;
                    }

                    audioEl
                        .play()
                        .then(() => console.log('Audio play success'))
                        .catch(err => {
                            console.error('Audio play error:', err);
                            if (err.name === 'AbortError') {
                                console.log('Ignoring AbortError on play');
                            }
                        });
                }
            });
    }, [consumers]);


    return (
        <>
            {/* {consumers
                ?.filter((c: any) => (c.track?.kind || c.kind) === "audio" && c.track?.readyState === "live")
                ?.map((consumer) => (
                    <audio
                        key={consumer.id}
                        ref={(el) => (audioRefs.current[consumer.id] = el)}
                        autoPlay
                        playsInline
                    />
                ))} */}
        </>
    );
};

export default AllAudioConsumers;
